import script from "./Order.vue?vue&type=script&lang=ts&setup=true"
export * from "./Order.vue?vue&type=script&lang=ts&setup=true"

import "./Order.vue?vue&type=style&index=0&id=2af2e0b4&lang=less"

const __exports__ = script;

export default __exports__